import { render, staticRenderFns } from "./AppointmentNew.vue?vue&type=template&id=03acebd8&lang=pug"
import script from "./AppointmentNew.vue?vue&type=script&lang=ts"
export * from "./AppointmentNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports